import { Col, Row, Stack, Tab, Tabs, Image, Container, Badge } from "react-bootstrap";
import { StoreItem } from "../components/StoreItem";
import { useTabContext, TAB_TYPES } from "../context/TabContext";
import StoreCardSkeleton from "../components/skeletons/StoreCard";
import openerPromoBanner from "/imgs/opener-promo-banner.svg";
import { useStoresByCategory } from "../lib/query/queries/useStoreQueries";
import { useNavigate } from "react-router-dom";
import { PullToRefreshWrapper } from "../components/pullRefresh";
import { Seo } from "../components/Seo";
import { generateHomeSEO } from "../lib/seo/metaGenerators";
import { useCachedImageSrc } from "../hooks/useCachedImageSrc";

const PROMO_BANNER_SRC =
  "https://firebasestorage.googleapis.com/v0/b/fineats-5dd74.firebasestorage.app/o/fineats-assets%2Fbanners%2FUpdate%20App%20Banner%20Color%20Theme.png?alt=media&token=305e712f-9213-464c-9651-4d0544e0fbdc";

function ShowSkeleton() {
  return (
    <Row md={2} xs={1} lg={3} className="g-3">
      {[...Array(6)].map((_, i) => (
        <Col key={i}>
          <StoreCardSkeleton />
        </Col>
      ))}
    </Row>
  );
}

export function Store() {
  const { activeTab, setActiveTab } = useTabContext();
  const navigate = useNavigate();

  // Keyed on activeTab, so switching tabs (setActiveTab below) refetches
  // automatically — the old code called fetchStoresByCategory once on mount
  // AND again on every tab click, duplicating the request the mount effect
  // was about to make for the same category.
  const { data: stores = [], isFetching, refetch } = useStoresByCategory(activeTab);
  const isLoading = isFetching;
  const cachedPromoBannerSrc = useCachedImageSrc(PROMO_BANNER_SRC);

  const handleTabChange = (category) => {
    setActiveTab(category);
  };

  const tabStyle = {
    padding: "0.5rem 1rem",
    border: "none",
    backgroundColor: "transparent",
    color: "#6c757d",
    fontWeight: "500",
    transition: "all 0.3s ease",
    borderBottom: "2px solid transparent",
  };

  const activeTabStyle = {
    ...tabStyle,
    color: "#0d6efd",
    borderBottom: "2px solid #0d6efd",
  };

  return (
    <PullToRefreshWrapper onRefresh={refetch}>
    <Seo {...generateHomeSEO()} />
    <Container className="py-4">
      <Stack gap={4}>
        <div className="position-relative w-100">
          <Image
            className="w-100 rounded-3 shadow-sm"
            src={cachedPromoBannerSrc}
            alt="Promotional banner"
          />
          <Badge 
            bg="primary" 
            className="position-absolute top-0 end-0 m-3"
            style={{ fontSize: "0.9rem" }}
          >
            New
          </Badge>
        </div>

        <div className="d-flex justify-content-between align-items-center">
          <h1 className="fw-bold mb-0">
            {activeTab === TAB_TYPES.FOOD ? "Food" : "Liquor"}
          </h1>
          <Badge bg="light" text="dark" className="px-3 py-2">
            {stores.length} Stores
          </Badge>
        </div>

        <Tabs
          defaultActiveKey={activeTab}
          id="store-category-tabs"
          className="mb-4 border-0"
          onSelect={handleTabChange}
          activeKey={activeTab}
        >
          <Tab
            eventKey={TAB_TYPES.FOOD}
            title={
              <span style={activeTab === TAB_TYPES.FOOD ? activeTabStyle : tabStyle}>
                🍔 Food
              </span>
            }
          >
            {isLoading ? (
              <ShowSkeleton />
            ) : stores.length > 0 ? (
              <Row md={2} xs={1} lg={3} className="g-4">
                {stores.map((item) => (
                  <Col key={item.id}>
                    <StoreItem {...item} tab={activeTab} />
                  </Col>
                ))}
              </Row>
            ) : (
              <div className="text-center py-5">
                <h4 className="text-muted">No stores found</h4>
                <p className="text-muted">Try selecting a different category</p>
              </div>
            )}
          </Tab>

          {/* <Tab
            eventKey={TAB_TYPES.BEVERAGES}
            title={
              <span style={activeTab === TAB_TYPES.BEVERAGES ? activeTabStyle : tabStyle}>
                🍷 Liquor
              </span>
            }
          >
            {isLoading ? (
              <ShowSkeleton />
            ) : stores.length > 0 ? (
              <Row md={2} xs={1} lg={3} className="g-4">
                {stores.map((item) => (
                  <Col key={item.id}>
                    <StoreItem {...item} tab={activeTab} />
                  </Col>
                ))}
              </Row>
            ) : (
              <div className="text-center py-5">
                <h4 className="text-muted">No stores found</h4>
                <p className="text-muted">Try selecting a different category</p>
              </div>
            )}
          </Tab> */}
        </Tabs>
      </Stack>
    </Container>
    </PullToRefreshWrapper>
  );
}
